/*
 * Системное событие ленты (prototype/Prototype.dc.html:1491). `--tint` приезжает инлайном из
 * тона события — тот же приём, что у `BookingStatusChip`: один компонент красится под любой тон
 * без веток в CSS.
 *
 * Числа — из копии КАРТОЧКИ (плитка 24, radius 7, иконка 13/2.4, margin 2px 2px). Копия экрана
 * «Чаты» (1360) даёт 22 / 6 / 12 / 2.6 и margin 2px 6px — справочник сводит обе к карточке.
 */
.root {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 2px 2px;
  padding: 9px 12px;
  border: 1px solid color-mix(in oklch, var(--tint) 22%, transparent);
  border-radius: 11px;
  background: color-mix(in oklch, var(--tint) 9%, var(--tint-on));
}

/*
 * Галка на плитке — `--on-accent`, а НЕ литеральный `#fff` из макета. Это не вкусовщина и не
 * унификация: ровно это отступление проект уже сделал осознанно и пометил «обратно не
 * откатывается» (docs/reference/contrast-audit.md, «Что делает фронт, пока ответа нет»):
 * «инициалы и подписи на цветных плитках красятся `var(--on-accent)`… в тёмной теме `#fff`
 * давал 2.35 : 1». Плитка события — тот же случай: в тёмной теме статусные токены СВЕТЛЕЮТ
 * (`--st-in` = oklch(72%)), и белая галка на ней тонет.
 *
 * Измерено зондом на ЖИВОЙ сборке (canvas → getImageData → WCAG), не прикинуто:
 *
 *     тёмная:  #fff — 2.36 : 1  (не берётся даже норма 3 : 1 для графики) · --on-accent — 7.68 : 1
 *     светлая: #fff — 4.75 : 1                                            · --on-accent — 4.58 : 1
 *
 * В светлой теме `--on-accent` ≈ белый (oklch 99%), то есть вид макета сохранён, а тёмная
 * перестаёт топить галку. Ровно тот размен, что описан в аудите.
 *
 * Исключение — бренд-иконки (`MessengerAvatar`): там белый оставлен намеренно, узнаваемость лого
 * WhatsApp/Telegram держится именно на нём. Галка брендом не является.
 */
.tile {
  display: grid;
  flex-shrink: 0;
  place-items: center;
  width: 24px;
  height: 24px;
  border-radius: 7px;
  background: var(--tint);
  color: var(--on-accent);
}

.text {
  flex: 1;
  min-width: 0;
}

.title {
  display: block;
  font-size: 12px;
  font-weight: 600;
}

/*
 * `--ink-3` и `--ink-4` — токены МАКЕТА для этих двух подписей, оставлены как есть. Но заливка
 * события (`--tint` 9% на `--panel`) — подложка, которой на момент аудита контраста ещё не
 * существовало, и в ТЁМНОЙ теме она светлее панели (oklch 27.4% против 23%), поэтому светлый
 * текст на ней теряет контраст. Измерено на живой сборке:
 *
 *     тёмная:  переход --ink-3 — 4.45 · время --ink-4 — 3.95   (норма AA 4.5 — не берётся)
 *     светлая: переход --ink-3 — 4.84 · время --ink-4 — 4.63   (берётся)
 *
 * Сам НЕ чиню и цифры не подгоняю: палитра — зона проектировщика, и аудит это прямо фиксирует
 * («Что делает фронт, пока ответа нет: ничего не меняет»). Промах маленький и живёт на подписи
 * 10px в тёмной теме; передан координатору в отчёте задачи 9, чинится правкой токена или
 * процента заливки, а не догадкой здесь.
 */
.transition {
  display: block;
  font-family: 'JetBrains Mono Variable', monospace;
  font-size: 10px;
  color: var(--ink-3);
}

.time {
  flex-shrink: 0;
  font-family: 'JetBrains Mono Variable', monospace;
  font-size: 10px;
  color: var(--ink-4);
}
